import React, { Component } from 'react';
import './index.css';
import moment from 'moment';
import CircleCountdownTimer from '../CircleCountdownTimer';

let intTimer;

class DayCounter extends Component {
    state = {
        days: 24,
        hours: 24,
        mins: 24,
        secs: 24,
        duration: 0,
        interval: 1000
    }

    componentDidMount() {
        var duration = moment.duration(this.props.timeCount, 'milliseconds');

        var interval = 1000;
        this.setState({ 
            days: duration.days(),
            hours: duration.hours(), 
            mins: duration.minutes(),
            secs: duration.seconds()
        });
        
        intTimer = setInterval(() => {            
            duration = moment.duration(duration - interval, 'milliseconds');

            this.setState({ 
                days: duration.days(),
                hours: duration.hours(), 
                mins: duration.minutes(),
                secs: duration.seconds()
            });

        }, interval);
    }
    componentWillUnmount() {
        clearInterval(intTimer)
    }

    render() {
        if(this.state.days < 0 || this.props.timeCount === 0 || (this.state.days === 0 && this.state.hours <= 0 && this.state.mins <=0 && this.state.secs <= 0 )) {
            return (<div></div>)
        }
        if(this.state.days > 0) 
        {
            return (
                <div id="clock" style={{display: this.props.displayState ? "block" : "none"}}>
                    <div className="days cell">{this.state.days}<span>days</span></div>
                    <div className="hours cell">{this.state.hours}<span>hours</span></div>
                    <div className="mins cell">{this.state.mins}<span>mins</span></div>                
                </div>
            );
        }
        return (
            <CircleCountdownTimer hours={this.state.hours} mins={this.state.mins} secs={this.state.secs} displayState={this.props.displayState}></CircleCountdownTimer>
        )
    }
}

export default DayCounter;